import {getRouteApi} from "@tanstack/react-router";

export const expedientsRouteApi = getRouteApi("/_app/sales/expedients/");
